import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// snakbar
import { Snackbar, Alert, CircularProgress } from "@mui/material";
import { Button, Form, Modal } from "react-bootstrap";

const EditTraderLayer = () => {
  const [imagePreview, setImagePreview] = useState(
    "assets/images/user-grid/user-grid-img13.png"
  );
  const location = useLocation();
  const tutorToEdit = location.state?.trader;
  // console.log("tutorToEdit: -------------------------------------", tutorToEdit);
  // setUserId(tutorToEdit?._id);
  const [formState, setFormState] = useState({
    name: "",
    email: "",
    phone: "",
    country_code: "",
    user_name: "",
    // roll_no: "",
    address: "",
    gender: "",
    trader_id: "",
    // admission_Date: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [roleName, setRoleName] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedCourseCategory, setSelectedCourseCategory] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [token, setToken] = useState("");
  const [savedDepartmentName, setSavedDepartmentName] = useState("");
  const [courseCategories, setCourseCategories] = useState("");
  const [courses, setCourses] = useState([]);
  const [isNameTouched, setIsNameTouched] = useState(false);
  const [isEmailTouched, setIsEmailTouched] = useState(false);
  const [isMobileTouched, setIsMobileTouched] = useState(false);
  const [batches, setBatches] = useState([]);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({});
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [enrolledCourseData, setEnrolledCourseData] = useState({});
  const [certificateImages, setCertificateImages] = useState({});
  const [imagePreviews, setImagePreviews] = useState({});
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [isCompleted, setIsCompleted] = useState(false);
  // snackbar
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [refferal, setRefferal] = useState("");
  const [userId, setUserId] = useState("");
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showCourseModal, setShowCourseModal] = useState(false);
  const [availableCourses, setAvailableCourses] = useState([]);
  const [purchaseLoading, setPurchaseLoading] = useState(null);
  const [showPaymentDetailsModal, setShowPaymentDetailsModal] = useState(false);
  const [selectedCoursePayments, setSelectedCoursePayments] = useState(null);
  const [selectedModalCourse, setSelectedModalCourse] = useState(null);
  const [amount, setAmount] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [paymentProof, setPaymentProof] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [modalImage, setModalImage] = useState("");
  // Add these functions
  const fetchAvailableCourses = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-Courses`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // Access the courses array from the data property
      setAvailableCourses(response.data.data || []);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setSnackbarMessage("Failed to fetch available courses");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      setAvailableCourses([]); // Reset to empty array on error
    }
  };

  const handlePurchaseCourse = async (courseId) => {
    setPurchaseLoading(courseId);
    try {
      await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/course/purchase`,
        {
          course_id: courseId,
          student_id: tutorToEdit._id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Refresh the enrolled courses
      await getErolledStudentById(tutorToEdit._id);

      setSnackbarMessage("Course purchased successfully");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
      setShowCourseModal(false);
    } catch (error) {
      console.error("Error purchasing course:", error);
      setSnackbarMessage(
        error.response?.data?.message || "Failed to purchase course"
      );
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setPurchaseLoading(null);
    }
  };
  const handleBatchAssigning = async (courseId, batchId) => {
    setPurchaseLoading(batchId);
    try {
      await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/course/trader/batch-assign`,
        {
          enrolled_course_id: courseId,
          batch_id: batchId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Refresh the enrolled courses
      await getErolledStudentById(tutorToEdit._id);

      setSnackbarMessage("Course purchased successfully");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
      setShowCourseModal(false);
    } catch (error) {
      console.error("Error purchasing course:", error);
      setSnackbarMessage(
        error.response?.data?.message || "Failed to purchase course"
      );
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setPurchaseLoading(null);
    }
  };

  // Add this useEffect
  useEffect(() => {
    if (showCourseModal) {
      fetchAvailableCourses();
    }
  }, [showCourseModal]);

  const readURL = (input) => {
    if (input.target.files && input.target.files[0]) {
      const file = input.target.files[0];

      // Allowed image types
      const allowedTypes = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "image/gif",
      ];

      if (!allowedTypes.includes(file.type)) {
        setSnackbarMessage(
          "Invalid file format! Please upload an image (PNG, JPG, JPEG, GIF)."
        );
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        return; // Stop further execution
      }

      // If valid image, read and preview it
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  useEffect(() => {
    if (tutorToEdit) {
      console.log("traderrrrrr info:----------- ", tutorToEdit);
      getErolledTraderId(tutorToEdit._id);
      const user = localStorage?.getItem("user");
      const parsedUser = JSON.parse(user);
      const role = parsedUser?.rolename;
      setUserId(tutorToEdit?._id);
      setRoleName(role);
      fetchRefferal();
      setFormState({
        name: tutorToEdit?.name,
        email: tutorToEdit?.email,
        phone: tutorToEdit?.mobile,
        country_code: tutorToEdit?.country_code,
        user_name: tutorToEdit?.user_name,
        address: tutorToEdit?.address,
        gender: tutorToEdit?.gender,
        trader_id: tutorToEdit?.trader_id,
      });
      setImagePreview(tutorToEdit.profile_url);
      setSelectedDepartment(tutorToEdit?.department?._id);
      setSavedDepartmentName(tutorToEdit?.department?.department_name);
      setSelectedCountry(tutorToEdit?.countriesData?._id);
      setSelectedState(tutorToEdit?.statesData?._id);
      setSelectedCity(tutorToEdit?.cityData?._id);
    } else {
      setError("No tutor data found.");
    }
  }, [tutorToEdit]);

  useEffect(() => {
    // const token1 = localStorage.getItem("token");
    const token1 = localStorage.getItem("token");
    setToken(token1);
    if (!token1) {
      // console.log("Access required");
      return;
    }
    fetchdepartment();
    fetchdCountry();
  }, []);

  useEffect(() => {
    fetchStatesByCountry();
  }, [selectedCountry]);

  useEffect(() => {
    fetchCityByState();
  }, [selectedState]);

  const fetchRefferal = async () => {
    setLoading(true);
    setError(null);
    const token = localStorage.getItem("token");
    try {
      if (!token) {
        console.log("Access required----------------------------------");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/users-referrals-data`,
        {
          params: {
            id: tutorToEdit?._id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response: attendence-----", response.data.data);

      setRefferal(response.data.data);
    } catch (error) {
      console.error("Failed to fetch Portfolios:", error);
      setError("Failed to fetch Portfolios.");
    } finally {
      setLoading(false);
    }
  };

  const getErolledTraderId = async (id) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-enrolled-course-by-traderid/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("response: ", response.data.data[0]);
      if (response.status === 200) {
        setEnrolledCourseData(response.data.data);
        setIsCompleted(response?.data?.data[0]?.completed);
        setImagePreviewUrl(response?.data?.data[0]?.certificateImage);
      }
    } catch (error) {
      // console.log(error);
    }
  };
  const handleImageChange = async (e, courseId) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviews((prev) => ({
          ...prev,
          [courseId]: reader.result, // Store preview per course
        }));
        setCertificateImages((prev) => ({
          ...prev,
          [courseId]: file, // Store actual file per course
        }));

        // Call API to update image
        uploadImage(courseId, file);
      };
      reader.readAsDataURL(file);
    }
  };

  // Function to upload image to API
  const uploadImage = async (courseId, file) => {
    const formData = new FormData();
    formData.append("certificateImage", file);
    const token = localStorage.getItem("token");
    if (!token) {
      // console.log("Access required");
      return;
    }
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/enrolled-course-update-img/${courseId}`,
        formData, // Pass formData directly as the body
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status !== 200) {
        // console.log("Failed to upload image");
      } else {
        // console.log("Upload successful:", response.data);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };
  const fetchdCountry = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-countries`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCountries(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchStatesByCountry = async () => {
    // console.log("selecetd countryyy: ", selectedCountry);
    if (!selectedCountry) {
      // console.log("selecetd countryyy: ", selectedCountry);

      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-states/${selectedCountry}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setStates(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchCityByState = async () => {
    if (!selectedState) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-cities/${selectedState}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCities(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchdepartment = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDepartments(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  // snakbar
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const getErolledStudentById = async (id) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-enrolled-course-by-studentid/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("response: ", response.data.data[0]);
      if (response.status === 200) {
        setEnrolledCourseData(response.data.data);
        setIsCompleted(response?.data?.data[0]?.completed);
        setImagePreviewUrl(response?.data?.data[0]?.certificateImage);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  const handleViewPaymentDetails = (course) => {
    setSelectedCoursePayments(course.payments);
    setShowPaymentDetailsModal(true);
  };

  // modal
  const handleShowModal = (course) => {
    setSelectedModalCourse(course);
    setShowModal(true);
  };

  const handleToggleStatus = async (item, e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    if (!token) {
      // console.log("Access required");
      return;
    }
    try {
      const updatedStatus = !item.completed; // Toggle the current status
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/enrolled-course-completed-update/${item._id}`,
        { status: updatedStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data", // Ensure the content type is set correctly
          },
        }
      );

      if (response.status === 200) {
        // Update the status locally
        // setCommunity((prevtrader) =>
        //   prevtrader.map((b) =>
        //     b._id === item._id ? { ...b, status: updatedStatus } : b
        //   )
        // );
        getErolledStudentById(tutorToEdit._id);

        setSnackbarMessage("Course completion Status updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Failed to toggle course completed:", error);
      setSnackbarMessage(
        "Failed to update course completion status. Please try again."
      );
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setAmount("");
    setPaymentMode("");
    setPaymentProof(null);
  };

  const handleModalSubmit = async () => {
    if (!selectedModalCourse || !amount || !paymentMode) {
      alert("Please fill in all payment details.");
      return;
    }

    // if (paymentMode === "Finance" && !paymentProof) {
    //   alert("Please upload payment proof for Finance payment mode.");
    //   return;
    // }

    const token = localStorage.getItem("token");
    if (!token) {
      // console.log("Access required");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("courseId", selectedModalCourse.course_id);
      formData.append("details_id", tutorToEdit._id);
      formData.append("amount", amount);
      formData.append("paymentMode", paymentMode);
      formData.append("dateOfPayment", new Date().toISOString());

      if (paymentProof) {
        formData.append("image", paymentProof);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/create-course-payment`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        // alert("Payment details saved successfully!");
        setSnackbarMessage("Payment details saved successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        getErolledStudentById(tutorToEdit._id);
        setShowModal(false);
        setAmount("");
        setPaymentMode("");
        setPaymentProof(null);
      } else {
        alert(`Error: ${response.data.message}`);
      }
    } catch (error) {
      console.error("Error saving payment details:", error);
      alert("Failed to save payment details.");
    }
  };

  const handleImageClick = (imageUrl) => {
    setModalImage(imageUrl);
    setShowImageModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formState.name || formState.name.length < 2) {
      setError(true); // Show error if name is invalid
      return; // Prevent form submission if validation fails
    }

    if (formState.user_name && formState.user_name.length < 2) {
      setError(true);
      return;
    }

    if (formState.phone.length < 8 || formState.phone.length > 15) {
      setError(true);
      return;
    }

    setLoading(true); // Start loading state
    try {
      // const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const formData = new FormData();
      formData.append("name", formState.name);
      formData.append("email", formState.email);
      formData.append("phone", formState.phone);
      formData.append("address", formState.address || ""); //Optional field
      formData.append("gender", formState.gender);
      formData.append("user_name", formState.user_name);
      formData.append("selectedCountry", selectedCountry);
      formData.append("selectedState", selectedState);
      formData.append("selectedCity", selectedCity);

      const imageInput = document.querySelector("#student-image");
      if (imageInput && imageInput.files[0]) {
        formData.append("image", imageInput.files[0]);
      }

      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/edit-trader/${tutorToEdit._id}`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
          "Content-Type": "multipart/form-data",
        }
      );

      // // console.log("response   ::", response);

      if (response.status && response.status === 200) {
        // alert("Mobile number should be in numbers.");
        // snackbar
        setSnackbarMessage("Updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/trader-list");
        }, 2000);
      }
    } catch (err) {
      if (err.response && err.response.status === 409) {
        // console.log("409 error detected");
        setSnackbarMessage(
          "This Email ID is already exists. Please check and update accordingly."
        );
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else if (err.response && err.response.status === 402) {
        setSnackbarMessage("Please fill out all required fields..");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage("Failed to update. Please try again");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    } finally {
      setLoading(false); // End loading state
    }
  };

  const handleCancel = () => {
    navigate("/trader-list");
  };

  return (
    <div className="row gy-4" style={styles.cardContent(loading)}>
      <div className="col-lg-4">
        <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
          <div className="pb-24 ms-16 mb-24 me-16  mt-20">
            <div className="text-center border border-top-0 border-start-0 border-end-0">
              <img
                src={
                  imagePreview || "assets/images/user-grid/user-grid-img14.png"
                }
                alt=""
                className="border br-white border-width-2-px w-200-px h-200-px rounded-circle object-fit-cover"
              />
              <h6 className="mb-0 mt-16">{formState.name}</h6>
              <span className="text-secondary-light mb-16">
                {formState.email}
              </span>
            </div>
            <div className="mt-24">
              <h6 className="text-xl mb-16">Personal Info</h6>
              <ul>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Trader ID
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {formState.trader_id}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Full Name
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {formState.name}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    User Name
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {formState.user_name}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Email
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {formState.email}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Phone Number
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {formState.phone}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Address
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {formState.address === "null" ? "" : formState.address}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-1 mb-12">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    {" "}
                    Gender
                  </span>
                  <span className="w-70 text-secondary-light fw-medium">
                    : {formState.gender}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-8">
        <div className="card h-100">
          <div className="card-body p-24">
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              id="pills-tab"
              role="tablist"
            ></ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-edit-profile"
                role="tabpanel"
                aria-labelledby="pills-edit-profile-tab"
                tabIndex={0}
              >
                <h6 className="text-md text-primary-light mb-16">
                  Profile Image
                </h6>
                {/* Upload Image Start */}
                <div className="mb-24 mt-16">
                  <div className="avatar-upload">
                    <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                      {/* File input hidden using CSS */}
                      <input
                        type="file"
                        id="student-image"
                        accept="image/*"
                        className="d-none" // This hides the file input
                        onChange={readURL}
                      />
                      <label
                        htmlFor="student-image" // Bind label to file input
                        className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-20 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                      >
                        <Icon icon="solar:camera-outline" className="icon" />
                      </label>
                    </div>
                    <div className="avatar-preview">
                      <div
                        id="imagePreview"
                        style={{
                          backgroundImage: `url(${
                            imagePreview ||
                            "assets/images/user-grid/user-grid-img14.png"
                          })`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      />
                    </div>
                  </div>
                </div>
                {/* Upload Image End */}
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Full Name
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="name"
                          name="name"
                          value={formState.name}
                          onChange={(e) => {
                            const regex = /^[A-Za-z\s]*$/; // Allow alphabets and spaces only
                            const value = e.target.value;
                            if (value === "" || value.trim() !== "") {
                              if (regex.test(value)) {
                                handleInputChange(e); // Update state only if valid
                              }
                            }
                          }}
                          onBlur={() => setIsNameTouched(true)} // Mark field as touched when focus is lost
                          placeholder="Enter Full Name"
                          required
                        />
                        {isNameTouched && (
                          <>
                            {formState.name && formState.name.length < 2 && (
                              <small className="text-danger-600">
                                Name must be at least 2 characters long
                              </small>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="user_name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          User Name
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="user_name"
                          name="user_name"
                          value={formState.user_name}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || value.trim() !== "") {
                              handleInputChange(e);
                            }
                          }}
                          onBlur={() => setIsNameTouched(true)} // Mark field as touched when focus is lost
                          placeholder="Enter User Name"
                          required
                        />
                        {isNameTouched && (
                          <>
                            {formState.user_name &&
                              formState.user_name.length < 2 && (
                                <small className="text-danger-600">
                                  User name must be at least 2 characters long
                                </small>
                              )}
                          </>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Email <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control radius-8"
                          id="email"
                          value={formState.email}
                          onChange={(e) => {
                            const value = e.target.value;
                            handleInputChange(e); // Update form state
                          }}
                          onBlur={() => setIsEmailTouched(true)} // Mark field as touched
                          placeholder="Enter email address"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="country"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Country
                          <span className="text-danger-600">*</span>
                        </label>
                        <div className="custom-select">
                          <select
                            value={selectedCountry || ""}
                            onChange={(e) => {
                              setSelectedState("");
                              setSelectedCity("");
                              const selectedValue = e.target.value;
                              setSelectedCountry(selectedValue || "");
                            }}
                            className="form-control radius-8"
                            id="country"
                            required
                          >
                            <option value="" disabled>
                              Select Country
                            </option>
                            {countries.map((country) => (
                              <option key={country._id} value={country._id}>
                                {country.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="state"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          State
                          <span className="text-danger-600">*</span>
                        </label>
                        <div className="custom-select">
                          <select
                            value={selectedState || ""}
                            onChange={(e) => {
                              setSelectedCity("");
                              const selectedValue = e.target.value;
                              setSelectedState(selectedValue || "");
                            }}
                            className="form-control radius-8"
                            id="country"
                            required
                          >
                            <option value="" disabled>
                              Select State
                            </option>
                            {states?.map((state) => (
                              <option key={state._id} value={state._id}>
                                {state.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="city"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          City
                        </label>
                        <div className="custom-select">
                          <select
                            value={selectedCity || ""}
                            onChange={(e) => {
                              const selectedValue = e.target.value;
                              setSelectedCity(selectedValue || "");
                            }}
                            className="form-control radius-8"
                            id="country"
                          >
                            <option value="" disabled>
                              Select City
                            </option>
                            {cities?.map((city) => (
                              <option key={city._id} value={city._id}>
                                {city.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="phone"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Contact
                          <span className="text-danger-600">*</span>
                        </label>
                        <div className="d-flex">
                          <input
                            type="text"
                            className="form-control radius-8"
                            style={{ width: "80px", marginRight: "8px" }} // Adjust width and margin
                            id="phonecode"
                            value={formState.country_code}
                            readOnly // Make the field non-editable
                            placeholder="Code"
                          />
                          <input
                            type="text"
                            className="form-control radius-8"
                            id="phone"
                            name="phone"
                            value={formState.phone}
                            onChange={(e) => {
                              const regex = /^[0-9]*$/; // Allow numbers only
                              const value = e.target.value;

                              if (
                                (regex.test(value) || value === "") &&
                                value.length <= 15 // Enforce max length
                              ) {
                                handleInputChange(e); // Update state only if valid
                              }
                            }}
                            onBlur={() => {
                              setIsMobileTouched(true); // Mark field as touched when focus is lost
                              if (
                                formState.phone.length < 8 ||
                                formState.phone.length > 15
                              ) {
                                setError(
                                  "Contact number must be between 8 and 15 digits."
                                );
                              } else {
                                setError(""); // Clear error if valid
                              }
                            }}
                            placeholder="Enter your contact number"
                            maxLength={15} // Ensure no more than 15 characters
                            required
                          />
                        </div>
                        {isMobileTouched && formState.phone && error && (
                          <small className="text-danger-600">
                            Contact number must be between 8 and 15 digits.
                          </small>
                        )}
                      </div>
                    </div>

                    {/* <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="phone"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Contact <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="phone"
                          name="phone"
                          value={formState.phone}
                          onChange={(e) => {
                            const regex = /^[0-9]*$/; // Allow numbers only
                            const value = e.target.value;

                            if (
                              (regex.test(value) || value === "") &&
                              value.length <= 15 // Enforce max length
                            ) {
                              handleInputChange(e); // Update state only if valid
                            }
                          }}
                          onBlur={() => {
                            setIsMobileTouched(true); // Mark field as touched
                            if (!formState.phone) {
                              setError("Contact number is required");
                            } else if (
                              formState.phone.length < 8 ||
                              formState.phone.length > 15
                            ) {
                              setError(
                                "Contact number must be between 8 and 15 digits."
                              );
                            } else {
                              setError(""); // Clear error if valid
                            }
                          }}
                          placeholder="Enter your contact number"
                          maxLength={15} // Ensure no more than 15 characters
                          required
                        />
                        
                        {isMobileTouched && formState.phone && error && (
                          <small className="text-danger-600">Contact number must be between 8 and 15 digits.</small>
                        )}

                      </div>
                    </div> */}

                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="address"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Address
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="address"
                          value={
                            formState.address === "null"
                              ? ""
                              : formState.address
                          }
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "" || value.trim() !== "") {
                              handleInputChange(e);
                            }
                          }}
                          placeholder="Enter address (optional)"
                        />
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="gender"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Gender
                          <span className="text-danger-600">*</span>
                        </label>
                        <select
                          id="gender"
                          name="gender"
                          value={formState.gender}
                          onChange={handleInputChange}
                          className="form-control radius-8"
                          required
                        >
                          <option value="" disabled>
                            Select Gender
                          </option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <button
                      type="button"
                      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                      // onClick={handleSubmit}
                    >
                      {loading && (
                        <div
                          className="loader-container"
                          style={styles.loaderContainer}
                        >
                          <CircularProgress />
                        </div>
                      )}
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <div className="row mt-5">
        <div className="accordion" id="dashboardAccordion">
          {roleName === "Admin" && (
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingCourseDetails">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseCourseDetails"
                  aria-expanded="false"
                  aria-controls="collapseCourseDetails"
                >
                  <h5 className="mb-0">Course Details</h5>
                </button>
              </h2>
              <div
                id="collapseCourseDetails"
                className="accordion-collapse collapse"
                aria-labelledby="headingCourseDetails"
                data-bs-parent="#dashboardAccordion"
              >
                <div className="accordion-body">
                  <div className="card-body py-24">
                    <div className="table-responsive scroll-sm">
                      <table className="table bordered-table sm-table mb-0">
                        <thead>
                          <tr>
                            <th scope="col">
                              <div className="d-flex align-items-center gap-10">
                                S.L
                              </div>
                            </th>
                            <th scope="col">Attendance</th>
                            <th scope="col">Course Name</th>
                            <th scope="col">Batch Details</th>
                            <th scope="col">Payment Details</th>
                            <th scope="col">Course Completion</th>
                            <th scope="col">Certificate</th>
                          </tr>
                        </thead>
                        <tbody>
                          {enrolledCourseData.length > 0 ? (
                            enrolledCourseData.map((course, index) => (
                              <tr key={course?._id}>
                                <td>{index + 1}</td>
                                <td>{course?.attendance_count}</td>
                                <td>{course?.course_name}</td>
                                <td>
                                  <div className="d-flex flex-column gap-2">
                                    {/* <span>{course?.batch_brief || 'No batch assigned'}</span> */}
                                    {roleName === "Admin" && (
                                      <select
                                        className="form-select radius-8"
                                        value={course?.batch_id || ""}
                                        onChange={(e) =>
                                          handleBatchAssigning(
                                            course?._id,
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option value="">Select Batch</option>
                                        {course?.batches?.ongoing?.length > 0 ||
                                        course?.batches?.upcoming?.length >
                                          0 ? (
                                          [
                                            ...(course.batches.ongoing || []),
                                            ...(course.batches.upcoming || []),
                                          ].map((batch) => (
                                            <option
                                              key={batch._id}
                                              value={batch._id}
                                            >
                                              {batch?.batch_name}
                                              {batch.batch_start_duration <=
                                              new Date().toISOString()
                                                ? " (Ongoing)"
                                                : " (Upcoming)"}
                                            </option>
                                          ))
                                        ) : (
                                          <option value="" disabled>
                                            No batches available
                                          </option>
                                        )}
                                      </select>
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <span className="text-md mb-0 fw-normal text-secondary-light">
                                    <br />
                                    {"Total amount paid:  "}
                                    {course?.total_amount_paid}
                                    <br />
                                    <br />
                                    <div className="d-flex gap-2">
                                      <button
                                        type="button"
                                        className="btn btn-info"
                                        onClick={() =>
                                          handleViewPaymentDetails(course)
                                        }
                                      >
                                        View Details
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => handleShowModal(course)}
                                      >
                                        + Add Payment
                                      </button>
                                    </div>
                                  </span>
                                </td>
                                <td>
                                  {Date.now() >
                                    new Date(
                                      course?.batch_start_duration
                                    ).getTime() &&
                                  Date.now() <
                                    new Date(
                                      course?.batch_end_duration
                                    ).getTime() ? (
                                    <span>Ongoing batch</span>
                                  ) : (
                                    <button
                                      onClick={(e) => {
                                        handleToggleStatus(course, e);
                                        getErolledStudentById(tutorToEdit._id);
                                      }}
                                      type="button"
                                      className={`bg-${
                                        course?.completed ? "success" : "danger"
                                      }-focus text-${
                                        course?.completed ? "success" : "danger"
                                      }-600 border border-${
                                        course?.completed ? "success" : "danger"
                                      }-main px-24 py-4 radius-4 fw-medium text-sm`}
                                    >
                                      {course?.completed
                                        ? "Completed"
                                        : "Not Completed"}
                                    </button>
                                  )}
                                </td>
                                <td>
                                  {course?.completed && (
                                    <div className="mb-20">
                                      <div className="upload-field d-flex flex-column">
                                        <input
                                          type="file"
                                          id={`certificateImage-${course._id}`}
                                          accept="image/*"
                                          onChange={(e) =>
                                            handleImageChange(e, course._id)
                                          }
                                          className="d-none"
                                        />
                                        <button
                                          type="button"
                                          onClick={() =>
                                            document
                                              .getElementById(
                                                `certificateImage-${course._id}`
                                              )
                                              .click()
                                          }
                                          className="btn btn-outline-primary"
                                        >
                                          <i className="fas fa-upload me-2"></i>{" "}
                                          Upload Certificate
                                        </button>
                                        {imagePreviews[course._id] ? (
                                          <img
                                            src={imagePreviews[course._id]}
                                            alt="Certificate Preview"
                                            className="img-thumbnail mt-2"
                                            style={{ maxHeight: "100px" }}
                                          />
                                        ) : course?.certificateImage ? (
                                          <img
                                            src={course?.certificateImage}
                                            alt="Certificate Preview"
                                            className="img-thumbnail mt-2"
                                            style={{ maxHeight: "100px" }}
                                          />
                                        ) : null}
                                      </div>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">
                                No course details found
                              </td>
                            </tr>
                          )}
                          <tr>
                            <td colSpan="7" className="text-center">
                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => setShowCourseModal(true)}
                                disabled={
                                  Array.isArray(enrolledCourseData) &&
                                  enrolledCourseData.some(
                                    (course) => !course?.completed
                                  )
                                }
                                title={
                                  Array.isArray(enrolledCourseData) &&
                                  enrolledCourseData.some(
                                    (course) => !course?.completed
                                  )
                                    ? "Complete existing courses before adding new ones"
                                    : ""
                                }
                              >
                                <i className="fas fa-plus me-2"></i>
                                Add New Course
                              </button>
                            </td>
                          </tr>
                        </tbody>
                        <Modal
                          show={showModal}
                          onHide={handleCloseModal}
                          centered
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Enter Payment Details</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <Form>
                              <Form.Group className="mb-3">
                                <Form.Label>Amount</Form.Label>
                                <Form.Control
                                  type="number"
                                  value={amount}
                                  onChange={(e) => setAmount(e.target.value)}
                                  placeholder="Enter amount"
                                />
                              </Form.Group>
                              <Form.Group className="mb-3">
                                <Form.Label>Payment Mode</Form.Label>
                                <div>
                                  <Form.Check
                                    type="radio"
                                    label="Finance"
                                    name="paymentMode"
                                    value="Finance"
                                    checked={paymentMode === "Finance"}
                                    onChange={(e) =>
                                      setPaymentMode(e.target.value)
                                    }
                                  />
                                  <Form.Check
                                    type="radio"
                                    label="Bank Transfer"
                                    name="paymentMode"
                                    value="Bank Transfer"
                                    checked={paymentMode === "Bank Transfer"}
                                    onChange={(e) =>
                                      setPaymentMode(e.target.value)
                                    }
                                  />
                                  <Form.Check
                                    type="radio"
                                    label="Payment by link"
                                    name="paymentMode"
                                    value="Payment by link"
                                    checked={paymentMode === "Payment by link"}
                                    onChange={(e) =>
                                      setPaymentMode(e.target.value)
                                    }
                                  />
                                </div>
                              </Form.Group>
                              <Form.Group className="mb-3">
                                <Form.Label>Payment Proof</Form.Label>
                                <Form.Control
                                  type="file"
                                  accept="image/*"
                                  onChange={(e) =>
                                    setPaymentProof(e.target.files[0])
                                  }
                                  placeholder="Upload payment proof"
                                />
                                {paymentProof && (
                                  <img
                                    src={URL.createObjectURL(paymentProof)}
                                    alt="Payment Proof Preview"
                                    className="mt-2"
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "200px",
                                    }}
                                  />
                                )}
                              </Form.Group>
                            </Form>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              type="button"
                              variant="secondary"
                              onClick={handleCloseModal}
                            >
                              Cancel
                            </Button>
                            <Button
                              type="button"
                              variant="primary"
                              onClick={handleModalSubmit}
                              // disabled={!paymentProof}
                            >
                              Submit
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        {/* Course List Modal */}
                        <Modal
                          show={showCourseModal}
                          onHide={() => setShowCourseModal(false)}
                          size="lg"
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Available Courses</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="table-responsive">
                              <table className="table bordered-table sm-table mb-0">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Course Name</th>
                                    <th>Description</th>
                                    <th>Price</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Array.isArray(availableCourses) &&
                                    availableCourses.map((course, index) => (
                                      <tr key={course?._id || index}>
                                        <td>{index + 1}</td>
                                        <td>{course?.coursename}</td>
                                        <td>{course?.description}</td>
                                        <td>
                                          {"$ "}
                                          {course?.fees}
                                        </td>
                                        <td>
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            onClick={() =>
                                              handlePurchaseCourse(course._id)
                                            }
                                            disabled={
                                              purchaseLoading === course._id
                                            }
                                          >
                                            {purchaseLoading === course._id ? (
                                              <span
                                                className="spinner-border spinner-border-sm me-1"
                                                role="status"
                                                aria-hidden="true"
                                              ></span>
                                            ) : null}
                                            Purchase
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                  {(!Array.isArray(availableCourses) ||
                                    availableCourses.length === 0) && (
                                    <tr>
                                      <td colSpan="5" className="text-center">
                                        No courses available
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              variant="secondary"
                              onClick={() => setShowCourseModal(false)}
                            >
                              Close
                            </Button>
                          </Modal.Footer>
                        </Modal>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Course Details Accordion Item */}
          {/* Payment Details Modal */}
          <Modal
            show={showPaymentDetailsModal}
            onHide={() => setShowPaymentDetailsModal(false)}
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>Payment Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="table-responsive">
                <table className="table bordered-table sm-table mb-0">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Amount</th>
                      <th>Date</th>
                      <th>Mode</th>
                      <th>Proof</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedCoursePayments &&
                    selectedCoursePayments.length > 0 ? (
                      selectedCoursePayments.map((payment, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{payment.payment_amount}</td>
                          <td>
                            {payment?.payment_date
                              ? new Date(
                                  payment?.payment_date
                                ).toLocaleDateString()
                              : "-"}
                          </td>
                          <td>{payment.payment_mode}</td>
                          <td>
                            {payment.payment_proof ? (
                              <button
                                className="btn btn-link"
                                onClick={() =>
                                  handleImageClick(payment.payment_proof)
                                }
                              >
                                View Proof
                              </button>
                            ) : (
                              "No proof available"
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No payment details available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowPaymentDetailsModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          {roleName === "Admin" && (
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingReferralDetails">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseReferralDetails"
                  aria-expanded="false"
                  aria-controls="collapseReferralDetails"
                >
                  <h5 className="mb-0">Referral Details</h5>
                </button>
              </h2>
              <div
                id="collapseReferralDetails"
                className="accordion-collapse collapse"
                aria-labelledby="headingCourseDetails"
                data-bs-parent="#dashboardAccordion"
              >
                <div className="accordion-body">
                  <div className="card-body py-24">
                    <h6 className="text-md text-primary-light mb-16">
                      Student Referral Details
                    </h6>
                    <div className="table-responsive scroll-sm">
                      <table className="table bordered-table sm-table mb-0">
                        <thead>
                          <tr>
                            <th scope="col">
                              <div className="d-flex align-items-center gap-10">
                                S.L
                              </div>
                            </th>
                            <th scope="col">Student name</th>
                            <th scope="col">Course Name</th>
                            <th scope="col">Total Amount Earned</th>
                          </tr>
                        </thead>
                        <tbody>
                          {refferal?.studentReferralss?.length > 0 ? (
                            refferal.studentReferralss.map((course, index) => (
                              <tr key={course?._id}>
                                <td>{index + 1}</td>
                                <td>{course?.name}</td>
                                <td>
                                  {course?.billing_details?.map(
                                    (bill, billIndex) => (
                                      <ul
                                        className="course-names-list"
                                        key={`bill-${billIndex}`}
                                      >
                                        <li className="course-name-item">
                                          {bill?.course_id?.coursename}
                                        </li>
                                      </ul>
                                    )
                                  )}
                                </td>
                                <td>
                                  {course?.studTotalReferralssAmount || "0"}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No referral details found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-body py-24">
                    <h6 className="text-md text-primary-light mb-16">
                      Trader Referral Details
                    </h6>
                    <div className="table-responsive scroll-sm">
                      <table className="table bordered-table sm-table mb-0">
                        <thead>
                          <tr>
                            <th scope="col">
                              <div className="d-flex align-items-center gap-10">
                                S.L
                              </div>
                            </th>
                            <th scope="col">Trader name</th>
                            <th scope="col">Membership Name</th>
                            <th scope="col">Total Amount Earned</th>
                          </tr>
                        </thead>
                        <tbody>
                          {refferal?.TraderReferralss?.length > 0 ? (
                            refferal.TraderReferralss.map((course, index) => (
                              <tr key={course?._id}>
                                <td>{index + 1}</td>
                                <td>{course?.name}</td>
                                <td>
                                  {course?.billing_details?.map(
                                    (bill, billIndex) => (
                                      <ul
                                        className="course-names-list"
                                        key={`bill-${billIndex}`}
                                      >
                                        <li className="course-name-item">
                                          {bill?.membership_id?.title}
                                        </li>
                                      </ul>
                                    )
                                  )}
                                </td>
                                <td>
                                  {course?.traderTotalReferralssAmount || "0"}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No referral details found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EditTraderLayer;
